import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 44 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#i-790531028__a)",
      d: "M22.756 4.795c-.025 2.09 1.764 3.256 3.111 3.95 1.385.71 1.85 1.167 1.845 1.803-.01.973-1.105 1.403-2.129 1.42-1.786.029-2.825-.51-3.65-.917l-.644 3.18c.829.402 2.362.754 3.953.769 3.734 0 6.177-1.946 6.19-4.963.015-3.829-5.016-4.04-4.982-5.752.012-.519.48-1.073 1.509-1.214.509-.07 1.913-.125 3.505.649L32.09.644C31.233.315 30.132 0 28.762 0c-3.514 0-5.986 1.972-6.006 4.795ZM38.094.265c-.682 0-1.256.42-1.513 1.064l-5.334 13.445h3.732l.742-2.166h4.56l.43 2.166H44L41.13.264h-3.036Zm.522 3.92 1.077 5.448h-2.95l1.873-5.449ZM18.232.264l-2.942 14.51h3.555l2.94-14.51h-3.554v.001Zm-5.26 0-3.7 9.875-1.498-8.396c-.176-.938-.87-1.48-1.64-1.48H.084L0 .687c1.242.285 2.653.744 3.508 1.235.523.3.672.562.844 1.274l2.836 11.58h3.757l5.76-14.51h-3.733"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "i-790531028__a",
        x1: "20.229",
        x2: "20.687",
        y1: "15.301",
        y2: "-.103",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#222357" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#254AA5"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "visa"}) } }